import React from "react";

const MedicationResources = ({ resources, onViewSummary }) => {
  return (
    <div className="resources-grid">
      {resources.map((resource, index) => (
        <div key={index} className="resource-card">
          <div className="resource-content">
            <a
              href={resource.url}
              target="_blank"
              rel="noopener noreferrer"
              className="resource-title"
            >
              {resource.name}
            </a>
            <p className="resource-description">{resource.description}</p>
            <button
              className="summary-button"
              onClick={() => onViewSummary(resource.summary)}
            >
              View Summary
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MedicationResources;
